import React from "react";
import { Reveal } from "./Motion";
import { Truck } from "lucide-react";
import { TRIP_ZONES, BUSINESS } from "../config";

export default function ServiceArea() {
  return (
    <section id="area" data-testid="area-section" className="relative bg-[#050505] py-24 md:py-36 border-t border-[var(--border-dim)]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16 max-w-3xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--accent)]">/ Service Area & Trip Fees</span>
          <h2 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4 leading-[0.9]">How far<br />we roll.</h2>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-px bg-[var(--border-dim)] border border-[var(--border-dim)]">
          {/* stylized radial map */}
          <div className="relative bg-[#0a0a0a] min-h-[380px] overflow-hidden grid-lines">
            <div className="absolute inset-0 flex items-center justify-center">
              {[1, 2, 3].map((r) => (
                <span key={r} className="absolute rounded-full border border-[var(--border-dim)]" style={{ width: `${r * 30}%`, height: `${r * 30}%` }} />
              ))}
              <span className="absolute rounded-full border border-dashed border-[var(--accent)]/40" style={{ width: "90%", height: "90%" }} />
              <div className="relative z-10 flex flex-col items-center gap-2">
                <span className="h-4 w-4 bg-[var(--accent)] rotate-45" />
                <span className="font-display font-bold uppercase text-lg">{BUSINESS.city}</span>
                <span className="font-mono text-[10px] uppercase tracking-widest text-[var(--text-secondary)]">Home Base</span>
              </div>
            </div>
            <div className="absolute bottom-4 left-4 flex items-center gap-2 text-[var(--text-secondary)]">
              <Truck size={16} className="text-[var(--accent)]" />
              <span className="font-mono text-[10px] uppercase tracking-widest">Radius-based pricing</span>
            </div>
          </div>

          {/* zones table */}
          <div className="bg-[#0a0a0a]">
            {TRIP_ZONES.map((z, i) => (
              <div key={z.zone} data-testid={`zone-${i}`} className="grid grid-cols-12 gap-2 items-center p-5 md:p-6 border-b border-[var(--border-dim)] last:border-0 hover:bg-[#101010] transition-colors group">
                <span className="col-span-2 font-mono text-[var(--accent)] text-sm">{z.zone}</span>
                <div className="col-span-6">
                  <p className="font-display font-bold uppercase text-base md:text-lg leading-tight">{z.area}</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-[var(--text-secondary)] mt-1">ETA · {z.eta}</p>
                </div>
                <span className="col-span-4 text-right font-mono text-sm md:text-base group-hover:text-[var(--accent)] transition-colors">{z.fee}</span>
              </div>
            ))}
            <div className="p-5 md:p-6 bg-[#050505]">
              <p className="text-[var(--text-secondary)] text-sm leading-relaxed">Out of town? No problem. We schedule long-distance Hill Country hauls at a flat per-mile rate — flag it on your bid request and we'll quote the trip fee up front.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
